var reDissectParts = /([01]+)?([0-9]{0,3})([0-9]{3})([0-9]{4})(.+)?/;

var formatPhone = function formatPhone(value, template) {
	if (!value) return '';

	var numbers = value.replace(/[^0-9]/g, '');
	var parts = numbers.match(reDissectParts);

	if (parts) {
		var display = parts[3] + '-' + parts[4];

		if (parts[2]) {
			display = parts[2] + '-' + display;
		}
		if (parts[1]) {
			display = parts[1] + '-' + display;
		}
		if (parts[5]) {
			display = display + ' ' + parts[5];
		}

		return display;
	}

	// If parsing failed, return the original value
	return value;
};

export default formatPhone;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@allpro/form-manager/es/formatters/formatPhone.js
// module id = 533
// module chunks = 0